<template>
  <span
    class="notification-level-badge inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-1.5 py-[3px] text-[10px] font-medium leading-none tracking-wide"
    :class="[LEVEL_CLASSES[level], { 'opacity-60': read }]"
    :data-level="level"
    :data-read="read ? 'true' : undefined"
  >
    <span class="h-1 w-1 shrink-0 rounded-full bg-current" aria-hidden="true" />
    {{ LEVEL_LABELS[level] }}
  </span>
</template>

<script setup lang="ts">
/**
 * NOTIF-003 — the level chip (Readdy design, 2026-10-21): Action needed wears the D&D yellow
 * badge tokens, Heads-up the blue ones, Info the light-blue accent. A read row keeps its colour,
 * dimmed, so a read Action needed stays recognisable in the All tab.
 */
import type { NotificationLevel } from '@/services/notificationsApi'
import { LEVEL_LABELS } from '@/lib/notifications/pages'

defineProps<{ level: NotificationLevel; read?: boolean }>()

const LEVEL_CLASSES: Record<NotificationLevel, string> = {
  action_needed: 'bg-badge-yellow text-badge-yellow',
  heads_up: 'bg-badge-blue text-badge-blue',
  info: 'bg-badge-sky text-badge-sky'
}
</script>

<style scoped>
.notification-level-badge {
  border-color: color-mix(in oklab, currentColor 40%, transparent);
}
</style>
